export default __webpack_public_path__ + "static/media/logo-white.a0c5f720.svg";